module.exports = __webpack_public_path__ + "fonts/5828a721270939224edfaea7e5f04a84.txt";